/*
 * Alinga Pre-Order (variant-level)
 * Keeps the Add to Cart button, ETA message and Pre-Order line-item property in sync
 * with the selected variant on product pages.
 * Qualifying variants are decided server-side (snippets/alinga-preorder-state.liquid)
 * and listed in <script data-alinga-preorder-json>.
 */
(function () {
  'use strict';

  var dataCache = {};

  function getData(productId) {
    if (dataCache[productId]) return dataCache[productId];
    var el = document.querySelector('script[data-alinga-preorder-json][data-product-id="' + productId + '"]');
    if (!el) return null;
    try {
      dataCache[productId] = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return dataCache[productId];
  }

  function getContainers() {
    return Array.prototype.slice.call(document.querySelectorAll('.product-area[data-product-id]'));
  }

  function selectedVariantId(container) {
    var el = container.querySelector('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]');
    return el ? String(el.value) : null;
  }

  function isBusy(btn) {
    return btn.classList.contains('adding') || btn.classList.contains('confirmation');
  }

  function buttonsFor(container) {
    var nodes = container.querySelectorAll(
      '.product-detail__form button[name="add"], .product-detail__form__action button[name="add"], ' +
      '.sticky-cart-form button[name="add"], .product-area__add-to-cart-xs button'
    );
    var extra = document.querySelectorAll('.pdp-sticky-cart button[name="add"], .product-area__add-to-cart-xs button');
    var all = Array.prototype.slice.call(nodes);
    Array.prototype.forEach.call(extra, function (n) { if (all.indexOf(n) === -1) all.push(n); });
    return all;
  }

  function setButton(btn, isPre, label) {
    if (isBusy(btn) || btn.hasAttribute('disabled')) return;
    if (isPre) {
      if (btn.textContent.trim() !== label) btn.textContent = label;
      btn.setAttribute('data-alinga-preorder-btn', 'true');
    } else if (btn.getAttribute('data-alinga-preorder-btn') === 'true') {
      /* Leaving a pre-order variant: the theme has already restored its own default text.
         If not (e.g. sticky bar not managed by the theme), restore the default string. */
      if (btn.textContent.trim() === label && window.theme && window.theme.strings && window.theme.strings.buttonDefault) {
        btn.innerHTML = window.theme.strings.buttonDefault;
      }
      btn.removeAttribute('data-alinga-preorder-btn');
    }
  }

  function apply(container, variantId) {
    var productId = container.getAttribute('data-product-id');
    var data = getData(productId);
    if (!data) return;
    var info = variantId ? data.variants[String(variantId)] : null;
    var isPre = !!info;
    var message = info && info.message ? info.message : '';
    var label = data.label || 'Pre-Order';

    container.classList.toggle('variant-status--preorder', isPre);

    buttonsFor(container).forEach(function (btn) { setButton(btn, isPre, label); });

    Array.prototype.forEach.call(container.querySelectorAll('[data-alinga-preorder-message]'), function (el) {
      el.textContent = message;
      if (isPre && message) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });

    /* Line-item property so the ETA reaches checkout, the order and order emails */
    var forms = container.querySelectorAll('form[action*="/cart/add"]');
    var sticky = document.querySelectorAll('.pdp-sticky-cart form[action*="/cart/add"]');
    var allForms = Array.prototype.slice.call(forms);
    Array.prototype.forEach.call(sticky, function (f) { if (allForms.indexOf(f) === -1) allForms.push(f); });
    allForms.forEach(function (form) {
      var prop = form.querySelector('input[data-alinga-preorder-prop]');
      if (!prop) return;
      prop.value = message || 'Yes';
      prop.disabled = !isPre;
    });
  }

  function applyAll() {
    getContainers().forEach(function (c) { apply(c, selectedVariantId(c)); });
  }

  /* Hook the theme's own variant handler so we run immediately after it rewrites the button */
  function patchTheme() {
    var om = window.theme && window.theme.OptionManager;
    if (!om || om.__alingaPatched || typeof om.updateButtons !== 'function') return !!(om && om.__alingaPatched);
    var original = om.updateButtons;
    om.updateButtons = function (variant, $container) {
      original.apply(this, arguments);
      try {
        var container = $container && $container[0] ? $container[0] : null;
        if (container && variant && variant.id) apply(container, variant.id);
      } catch (e) { /* never break the theme */ }
    };
    om.__alingaPatched = true;
    return true;
  }

  function observeButtons() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () { applyAll(); });
    getContainers().forEach(function (c) {
      buttonsFor(c).forEach(function (btn) {
        observer.observe(btn, { childList: true, characterData: true, subtree: true });
      });
    });
  }

  function init() {
    if (!getContainers().length) return;
    patchTheme();
    applyAll();
    observeButtons();
    /* Fallbacks for variant pickers that update the selector without calling updateButtons */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') { setTimeout(applyAll, 0); }
    });
    window.addEventListener('popstate', applyAll);
    /* theme.js initialises option handling after load - re-sync once it has */
    window.addEventListener('load', function () { patchTheme(); applyAll(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
